export default __webpack_public_path__ + "static/media/genesis.c15f819f.mp4";